import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { CARD_TYPES } from '../../../shared/constants';
import { IMdBody } from '../../../types/shared';

import { ReactMarkdownExtended } from '../../../utils/generic';
import { parseSectionID } from '../../../utils/string-utils';

import Colors from '../../../styles/colors';
import { Body, H2 } from '../../../styles/generic';

interface Props {
  title?: string;
  body?: IMdBody;
  children?: ReactNode | ReactNode[];
  anchorName?: string;
}

const Disclaimer = ({ title, body, children, anchorName }: Props) => {
  const id = parseSectionID(CARD_TYPES.disclaimer, anchorName);
  return (
    <Component id={id}>
      {title && <StyledH2 data-testid="title">{title}</StyledH2>}
      {children && (
        <StyledBody data-testid="description">{children}</StyledBody>
      )}
      {body?.childMarkdownRemark.rawMarkdownBody && (
        <Body data-testid="description">
          <ReactMarkdownExtended componentType={CARD_TYPES.disclaimer}>
            {body?.childMarkdownRemark.rawMarkdownBody}
          </ReactMarkdownExtended>
        </Body>
      )}
    </Component>
  );
};

export default Disclaimer;

export const Component = styled.div`
  background: ${Colors.white};
  box-shadow: ${({ theme }) => theme.elevations.abnElevationWell};
  box-sizing: border-box;
  max-width: 800px;
  padding: 32px;
`;

const StyledH2 = styled(H2)`
  margin-top: 0;
  padding-top: 0;
`;

const StyledBody = styled(Body)`
  p {
    margin: 0;
  }
`;
